/* INTEGY V224 — desktop search speed prefetch + layout hooks — 10JUN2026 */
(function(){
  'use strict';
  if (window.INTEGY_V224_DESKTOP_SPEED_LOADED) return;
  window.INTEGY_V224_DESKTOP_SPEED_LOADED = true;

  function m(q){ try { return window.matchMedia && window.matchMedia(q).matches; } catch(e){ return false; } }
  if (!m('(min-width: 861px)')) return;

  document.documentElement.classList.add('integy-v224-desktop-speed');

  var prefetched = Object.create(null);
  function prefetch(url){
    if (!url || prefetched[url]) return;
    prefetched[url] = 1;
    try {
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.as = 'fetch';
      l.href = url;
      l.crossOrigin = 'anonymous';
      document.head.appendChild(l);
    } catch(e) {}
    try { fetch(url, {credentials:'same-origin', priority:'low'}).catch(function(){}); } catch(e) {}
  }

  function commonPrefetch(){
    var urls = window.INTEGY_V224_DESKTOP_SEARCH_PREFETCH || [];
    var i = 0;
    function next(){
      if (i >= urls.length) return;
      prefetch(urls[i++]);
      setTimeout(next, 28);
    }
    next();
  }

  function hotPrefetchForValue(v){
    v = String(v || '').trim().toLowerCase();
    if (v.length < 2) return;
    var map = window.INTEGY_V224_DESKTOP_SEARCH_HOTMAP || {};
    var k = v.replace(/[^a-z0-9]/g,'').slice(0,2);
    var k3 = v.replace(/[^a-z0-9]/g,'').slice(0,3);
    [k, k3].forEach(function(x){
      if (map[x]) prefetch(map[x]);
    });
  }

  function qsa(sel, root){ try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch(e){ return []; } }
  function formForInput(input){ return input && input.closest ? input.closest('form[action*="/search"],form[role="search"],.integy-collections-hub__search,.live-search-form') : null; }
  function isSearchInput(input){
    return input && input.matches && input.matches('input[type="search"],input[name="q"],input[name="search"],input[name="query"]') && formForInput(input);
  }

  function earlyStatus(input){
    if (!isSearchInput(input) || String(input.value || '').trim().length < 2) return;
    var panel = document.getElementById('integy-v204-one-search-panel');
    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'integy-v204-one-search-panel';
      panel.className = 'integy-v204-one-search-panel';
      panel.setAttribute('role','listbox');
      panel.setAttribute('aria-label','Search suggestions');
      document.body.appendChild(panel);
    }
    if (!panel.innerHTML || panel.textContent.indexOf('Searching products') === -1) {
      panel.innerHTML = '<div class="integy-v224-searching">Searching products, collections, and thumbnails…</div>';
    }
    try {
      var r = input.getBoundingClientRect();
      panel.style.position = 'fixed';
      panel.style.left = Math.max(8, Math.round(r.left)) + 'px';
      panel.style.top = Math.round(r.bottom + 6) + 'px';
      panel.style.width = Math.max(360, Math.round(r.width)) + 'px';
      panel.style.zIndex = '2147483640';
    } catch(e) {}
  }

  document.addEventListener('focusin', function(e){
    if (!isSearchInput(e.target)) return;
    commonPrefetch();
    hotPrefetchForValue(e.target.value);
    earlyStatus(e.target);
  }, true);

  document.addEventListener('input', function(e){
    if (!isSearchInput(e.target)) return;
    hotPrefetchForValue(e.target.value);
    earlyStatus(e.target);
  }, true);

  function markQuickshop(){
    qsa('.modal--quickshop-full,[data-modal-container].modal--quickshop-full').forEach(function(m){
      m.classList.add('integy-v224-quickshop');
    });
  }
  function fixMasthead(){
    if (!document.body || !document.body.classList.contains('template-collection')) return;
    qsa('.productgrid--masthead,.collection--masthead,.collection-header').forEach(function(el){
      el.classList.add('integy-v224-collection-masthead');
      el.style.setProperty('width','min(1640px, calc(100vw - 40px))','important');
      el.style.setProperty('max-width','min(1640px, calc(100vw - 40px))','important');
      el.style.setProperty('margin-left','20px','important');
      el.style.setProperty('margin-right','20px','important');
      el.style.setProperty('overflow','visible','important');
      qsa('.collection--description,[data-collection-description],.rte', el).forEach(function(desc){
        desc.style.setProperty('max-height','none','important');
        desc.style.setProperty('overflow','visible','important');
        desc.style.setProperty('white-space','normal','important');
      });
    });
  }
  function boot(){ markQuickshop(); fixMasthead(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  window.addEventListener('pageshow', function(){ setTimeout(boot,0); }, {passive:true});
  setInterval(markQuickshop, 500);

  if ('requestIdleCallback' in window) requestIdleCallback(commonPrefetch, {timeout: 2500});
  else setTimeout(commonPrefetch, 1600);
})();
